import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import {NumberPicker} from 'react-widgets';
import localizer from 'react-widgets-simple-number';

import AutoSaveField from './abstract/AutoSaveField.jsx';

class AutoSaveNumberPicker extends React.Component {

  constructor(props) {
    super(props);
    localizer();
  }

  getValueFromOnChange = ( event ) => {
    return event;
  };

  render() {
    return (
        <AutoSaveField  control={NumberPicker}
                        getValueFromOnChange={this.getValueFromOnChange}
                        placeholder={this.props.placeholderKey ? this.props.intl.formatMessage({ id: this.props.placeholderKey})  : ""}
                        min={this.props.min}
                        max={this.props.max}
                        {...this.props}
                        />
    );
  }
}

AutoSaveNumberPicker.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(AutoSaveNumberPicker);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveNumberPicker.jsx